var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPurpleCircleService(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 79,
    viewBox: "0 0 90 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.826 0C60.6414 0 70.2857 9.642 70.2857 21.6189C70.2857 32.598 59.657 39.4286 48.826 39.4286C40.1294 39.4286 35.1429 30.4345 35.1429 21.6189C35.1429 11.588 38.9304 0 48.826 0Z",
    fill: "#AEAEEE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2016 36.939C24.6469 36.5783 30.5712 37.2951 34.0884 41.4165C37.6904 45.6373 36.9792 51.5193 36.3225 57.001C35.5146 63.7447 35.6995 71.504 30.0247 75.3382C23.6406 79.6515 14.6082 80.0918 7.98394 76.1475C1.81941 72.4769 0.30518 64.5708 0.0117997 57.4674C-0.214821 51.9805 2.85288 47.2706 6.62462 43.2357C9.97909 39.6473 14.2676 37.2658 19.2016 36.939Z",
    fill: "#AEAEEE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.0309 41.1449C78.8225 41.0562 81.7907 43.8583 84.3499 46.6836C87.238 49.8719 90.3999 53.3273 89.9585 57.6244C89.463 62.4489 86.5381 67.1575 82.065 68.9291C77.8428 70.6013 73.6162 67.7021 69.53 65.7152C65.4447 63.7288 60.0268 62.3316 59.2297 57.8257C58.4453 53.392 63.1544 50.3624 66.238 47.1072C68.8053 44.397 71.317 41.2318 75.0309 41.1449Z",
    fill: "#AEAEEE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurpleCircleService);
export default __webpack_public_path__ + "static/media/purple-circle-service.758efc868d42a5a49b4da56f3ab532fe.svg";
export { ForwardRef as ReactComponent };